export default function inputWithLabel($compile, $parse) {
  'ngInject';

  return {
    scope: true,
    link($scope, $element, $attrs) {
      // $watchCollection can watch an object by also watching its properties (one level deep)
      $scope.$watchCollection($attrs.inputWithLabel, refresh);
      $scope.$watch(
        () => $element[0].offsetParent,
        () => {
          const parsedOptions = $parse($attrs.inputWithLabel)($scope);
          refresh(parsedOptions);
        }
      );

      const $input = $element.children();
      const $label = $compile(
        '<div class="input-with-label-label align-{{ align }}" ng-show="showLabel">{{ value }}</div>'
      )($scope);
      $element.append($label);

      const defaultOptions = {
        align: 'left',
        offset: 12,
        boundaryOffset: 12,
        value: 'Label',
        showLabel: true,
      };

      function refresh(optionsArg = {}) {
        const options = { ...defaultOptions, ...optionsArg };

        if (!options.value) {
          options.showLabel = false;
        }

        Object.assign($scope, options);

        $label.css(options.align, `${options.boundaryOffset}px`);

        $scope.$$postDigest(() => {
          if (options.showLabel) {
            const labelWidth =
              'predefinedWidth' in options ? options.predefinedWidth : $label[0].offsetWidth;
            $input.css(
              `padding-${options.align}`,
              `${labelWidth + options.offset + options.boundaryOffset}px`
            );
          } else {
            $input.css(`padding-${options.align}`, '');
          }
        });
      }
    },
  };
}
